import { useCallback, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useAuth } from "../use-auth";
import { keepUserDataLocalStorage } from 'crk-front-lib';

import { RUN_MODE, DEMO_USER, DEMO_PASSWORD } from '../configs/constant.json';

export function LogIn() {
  const auth = useAuth();
  const history = useHistory();

  const location = useLocation();
  const search = new URLSearchParams(location.search);
  const app_id = search.get('app');
  const from_page = search.get('from');

  const usernameFromLocalStorage = localStorage.getItem('username');

  const [labelMessage, setLabelMessage] = useState({
    text: 'Please input username and password',
    classes: ''
  })

  const handleSignIn = useCallback(
    () => {
      if (window.opener && !window.appWindow) {
        window.appWindow = window.opener;
      }

      localStorage.clear();

      const form = new FormData(document.getElementById('loginForm'));
      let _data = {email: form.get('username'), password: form.get('password')};
      // console.info(_data);
      if (RUN_MODE && RUN_MODE.match(/devel/i)) {
        if (_data.email.trim().length === 0) {
          _data.email = DEMO_USER;
          _data.password = DEMO_PASSWORD;
        }
      }

      fetch(`/api/v2/signin`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(_data)
      })
      .then(res => res.json())
      .then(json => {
          // console.info(json);
          if (json.code.match(/ok/i)) {
            // Keep to local storage
            keepUserDataLocalStorage(json);
            auth.signin(json.user);
            /*
            if(window.opener) {
              window.opener.postMessage(json, '*');
            }
            */
            if (app_id) {
              window.opener.postMessage({...json, from: 'signin'}, '*');
              history.replace(`/subscribe/${app_id}`);
            } else if(window.opener) {
              window.opener.postMessage(json, '*');
              window.close();
            } else {
              history.push('/member/home')
            }
          } else {
            const _msg = {...labelMessage};
            _msg.text = json.message;
            _msg.classes = 'text-danger';

            setLabelMessage(_msg);
          }
      })
    },
    [app_id, auth, history, labelMessage],
  )

  const handleKeyDown = useCallback((e) => {
    // console.info(e);
    if (e.keyCode === 13) handleSignIn();
  },[handleSignIn]);

  return (
    <div className="row justify-content-center">

      <div className="col-xl-10 col-lg-12 col-md-9 offset-md-1">

        <div className="card o-hidden border-0 shadow-lg my-5">
          <div className="card-body p-0">
            {/* Nested Row within Card Body */}
            <div className="row">
              <div className="col-lg-6 d-none d-lg-block bg-login-image my-1"></div>
              <div className="col-lg-6">
                <div className="p-5">
                  <div className="text-center">
                    <h1 className="h4 text-gray-900 mb-4">Welcome Back!</h1>
                  </div>
                  <form className="user" id="loginForm">
                    <div className="form-group">
                      <input name="username" type="text" id="username"
                        className="form-control form-control-user" placeholder="Email Address"
                        defaultValue={usernameFromLocalStorage}
                        autoComplete="off" />
                    </div>
                    <div className="form-group">
                      <input name="password" type="password" id="password"
                        className="form-control form-control-user" placeholder="Password"
                        onKeyDown={handleKeyDown}
                        autoComplete="off" />
                    </div>
                    <div className="form-group">
                      <div className="custom-control custom-checkbox small d-none">
                        <input type="checkbox" className="custom-control-input" id="customCheck" />
                        <label className="custom-control-label" htmlFor="customCheck">Remember Me</label>
                      </div>
                    </div>
                    <button type="button" id='btnLogin' 
                        className="btn btn-primary btn-user btn-block"
                        onClick={handleSignIn}>
                      Login
                    </button>
                    <hr />
                    <p id='message' className={labelMessage.classes}>{labelMessage.text}</p>
                    {/*
                    <a href="index.html" className="btn btn-google btn-user btn-block">
                      <i className="fab fa-google fa-fw"></i> Login with Google
                    </a>
                    <a href="index.html" className="btn btn-facebook btn-user btn-block">
                      <i className="fab fa-facebook-f fa-fw"></i> Login with Facebook
                    </a>
                    */}
                  </form>
                  <hr />
                  <div className="text-center">
                    <Link className="small" to="forgot-password">Forgot Password?</Link>
                  </div>
                  <div className="text-center">
                    <Link className="small" 
                      to={"/register" + (app_id ? `?app=${app_id}&from=${from_page || ''}` : '')}
                      replace>Create an Account!</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      {/* <a href="https://storyset.com/people">Illustration by Freepik Storyset</a> */}
    </div>

  );
}

